@if (entry?.base?.display) {
  <div>
    <app-member-lookup
      [zipSegment]="zipSegment"
      (memberLookupResponse)="onMemberLookupResponse($event)"
      (crosswalkResponse)="onCrosswalkResponse($event)">
    </app-member-lookup>
    @if (this.isMemberValid && !isCrosswalkValid) {
      <mat-error class="crosswalk-error">Member is not eligible for Whole Health Balance. Group information is invalid.</mat-error>
    }
  </div>
}